import React from 'react';
interface GoogleLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
}
export function GoogleLoginModal({
  isOpen,
  onClose,
  onLogin
}: GoogleLoginModalProps) {
  if (!isOpen) return null;
  return <>
      {/* Backdrop - Charcoal overlay ~60% opacity */}
      <div className="fixed inset-0 bg-[#111214]/60 backdrop-blur-[2px] z-50 transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-166" />

      {/* Modal Container */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-167">
        <div className="relative w-full max-w-[420px] bg-[#F5F5F5] rounded-xl shadow-2xl pointer-events-auto transform transition-all" role="dialog" aria-modal="true" aria-labelledby="modal-title" onClick={e => e.stopPropagation()} data-id="element-168">
          {/* Close button - subtle, top right */}
          <button onClick={onClose} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-black/5" aria-label="Close" data-id="element-169">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-170">
              <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-171" />
            </svg>
          </button>

          <div className="px-8 py-10 md:px-10 md:py-12 flex flex-col items-center text-center" data-id="element-172">
            {/* Title */}
            <h2 id="modal-title" className="text-[#0A0A0A] font-medium text-lg uppercase tracking-wider mb-3" data-id="element-173">
              Save Your Decode
            </h2>

            {/* Subline */}
            <p className="text-gray-500 text-sm mb-10 leading-relaxed max-w-[280px]" data-id="element-174">
              Sign in to download and access this later.
            </p>

            {/* Primary Action - Google Button */}
            <button onClick={onLogin} className="w-full py-3.5 px-4 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center gap-3 group" data-id="element-175">
              {/* Google Icon */}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0" aria-hidden="true" data-id="element-176">
                <path d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z" fill="#4285F4" data-id="element-177" />
                <path d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z" fill="#34A853" data-id="element-178" />
                <path d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z" fill="#FBBC05" data-id="element-179" />
                <path d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.19 5.736 7.395 3.977 10 3.977z" fill="#EA4335" data-id="element-180" />
              </svg>
              <span className="text-[#0A0A0A] font-medium text-sm" data-id="element-181">
                Continue with Google
              </span>
            </button>

            {/* Microcopy */}
            <p className="mt-8 text-[10px] text-gray-400 uppercase tracking-wider leading-relaxed max-w-[260px]" data-id="element-182">
              We do not send marketing emails. Nothing is stored unless you
              choose to save it.
            </p>
          </div>
        </div>
      </div>
    </>;
}